var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1206_28380)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1206_28380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16.106,
    y: 16.207,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_1206_28380)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7349 39.4375C49.8091 39.8594 51.356 41.6875 51.356 43.832C51.356 46.3281 49.3169 48.332 46.856 48.332H33.9185C31.106 48.332 28.856 46.082 28.856 43.2695C28.856 41.0898 30.2622 39.1914 32.231 38.5234C32.231 38.418 32.231 38.3125 32.231 38.207C32.231 35.1133 34.7271 32.582 37.856 32.582C39.9302 32.582 41.7583 33.7422 42.7075 35.4297C43.2349 35.043 43.9028 34.832 44.606 34.832C46.4692 34.832 47.981 36.3438 47.981 38.207C47.981 38.6641 47.8755 39.0508 47.7349 39.4375ZM43.7622 42.7422C44.1138 42.4258 44.1138 41.8984 43.7622 41.582C43.4458 41.2305 42.9185 41.2305 42.6021 41.582L40.9497 43.2344V37.9258C40.9497 37.4688 40.563 37.082 40.106 37.082C39.6138 37.082 39.2622 37.4688 39.2622 37.9258V43.2344L37.5747 41.582C37.2583 41.2305 36.731 41.2305 36.4146 41.582C36.063 41.8984 36.063 42.4258 36.4146 42.7422L39.5083 45.8359C39.5786 45.9414 39.7896 46.082 40.106 46.082C40.3872 46.082 40.5981 45.9414 40.6685 45.8359L43.7622 42.7422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.106,
    y: 17.207,
    width: 46,
    height: 46,
    rx: 23,
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1206_28380",
    x: -3.89404,
    y: 1.20703,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1206_28380"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1206_28380",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1206_28380",
    x1: 31.7759,
    y1: 64.207,
    x2: 64.106,
    y2: 31.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F19837"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECC962"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1206_28380"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(0.105957 0.207031)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5c06080107a4c95191c1c345e6edff09.svg";
export { ForwardRef as ReactComponent };